<template>
  <div class="bg bg-topo" aria-hidden="true">
    <svg class="art" viewBox="0 0 1600 720" preserveAspectRatio="xMaxYMin slice">
      <path v-for="ring in rings" :key="ring.k" :class="ring.accent ? 'w a' : 'w'" :d="ring.d" />
    </svg>
  </div>
</template>

<script>
// Courbes de niveau organiques qui partent du coin supérieur droit
function smoothPath(points) {
  let d = `M${points[0][0].toFixed(1)} ${points[0][1].toFixed(1)}`;
  for (let i = 1; i < points.length - 1; i++) {
    const [x0, y0] = points[i];
    const [x1, y1] = points[i + 1];
    d += ` Q${x0.toFixed(1)} ${y0.toFixed(1)} ${((x0 + x1) / 2).toFixed(1)} ${((y0 + y1) / 2).toFixed(1)}`;
  }
  const last = points[points.length - 1];
  return d + ` L${last[0].toFixed(1)} ${last[1].toFixed(1)}`;
}

function buildRings() {
  const cx = 1520;
  const cy = -60;
  const rings = [];
  for (let k = 0; k < 16; k++) {
    const r = 70 + k * 42;
    const points = [];
    for (let i = 0; i <= 120; i++) {
      const a = (Math.PI * i) / 120;
      const rr = r * (1 + 0.07 * Math.sin(3 * a + k * 0.35) + 0.04 * Math.sin(7 * a - k * 0.2));
      points.push([cx + rr * Math.cos(a), cy + rr * Math.sin(a)]);
    }
    rings.push({ k, d: smoothPath(points), accent: k === 3 || k === 9 });
  }
  return rings;
}

const RINGS = buildRings();

export default {
  name: "TopoBackground",
  data: () => ({ rings: RINGS }),
};
</script>
